// disable submit buttons on form submit
const forms = document.querySelectorAll('form')
forms.forEach(form => form.addEventListener('submit', event => event.submitter.disabled = true))
